import { render, staticRenderFns } from "./joinEdit.vue?vue&type=template&id=6d637232&scoped=true&"
import script from "./joinEdit.vue?vue&type=script&lang=js&"
export * from "./joinEdit.vue?vue&type=script&lang=js&"
import style0 from "./joinEdit.vue?vue&type=style&index=0&id=6d637232&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d637232",
  null
  
)

export default component.exports